@let coilRequest = coilRequestInput();
@let unitData = unitDataInput();
<fieldset>
  <legend class="keyLabel">{{ fieldLabel() }}</legend>
  <div class="content">
    @if (!coilRequest.isElectricHeat) {
      <div class="detailRow">
        <label class="displayLabel">Total Load Target*:</label>
        @if (coilRequest.isCooling) {
          <span>
            <input type="number" class="inputValue" [(ngModel)]="unitData.coolingTargetTotalLoad" (change)="nonRatedValueChange()"/>
          </span>
        }
        @if (!coilRequest.isCooling) {
          <span>
            <input type="number" class="inputValue" [(ngModel)]="unitData.heatingTargetTotalLoad" (change)="nonRatedValueChange()"/>
          </span>
        }
        <label class="unitLabel">{{ getCapacityUnits() }}</label>
      </div>
    }
    @if (coilRequest.isCooling) {
      <div class="detailRow">
        <label class="displayLabel">Dry Bulb:</label>
        <input type="number" #coolingEnteringDryBulb class="inputValue" [(ngModel)]="coilRequest.enteringDryBulb" (change)="inputValueChange('USCEDB', coolingEnteringDryBulb.value)"/>
        <label class="unitLabel">{{ getTemperatureUnits() }}</label>
      </div>
    }
    @if (!coilRequest.isCooling) {
      <div class="detailRow">
        <label class="displayLabel">Dry Bulb:</label>
        <input type="number" #heatingEnteringDryBulb class="inputValue" [(ngModel)]="coilRequest.enteringDryBulb" (change)="inputValueChange('USHEDB', heatingEnteringDryBulb.value)"/>
        <label class="unitLabel">{{ getTemperatureUnits() }}</label>
      </div>
    }
    @if (coilRequest.isCooling) {
      <div class="detailRow">
        <label class="displayLabel">Wet Bulb:</label>
        <input type="number" #coolingEnteringWetBulb class="inputValue" [(ngModel)]="coilRequest.enteringWetBulb" (change)="inputValueChange('USCEWB', coolingEnteringWetBulb.value)"/>
        <label class="unitLabel">{{ getTemperatureUnits() }}</label>
      </div>
    }
    @if (coilRequest.fluidType) {
      <div class="detailRow">
        <label class="displayLabel">Fluid Temp:</label>
        <input type="number" class="inputValue" [(ngModel)]="coilRequest.enteringFluidTemperature" (change)="nonRatedValueChange()"/>
        <label class="unitLabel">{{ getTemperatureUnits() }}</label>
      </div>
    }
    @if (coilRequest.fluidType) {
      <div class="detailRow">
        <label class="displayLabel">Fluid Type:</label>
        <select class="inputSelection" [(ngModel)]="coilRequest.fluidType" [disabled]="true">
          <option [value]="'W'">Water</option>
          <option [value]="'E'">Ethylene</option>
          <option [value]="'P'">Propylene</option>
        </select>
      </div>
    }
    @if (showGlycolPercent()) {
      <div class="detailRow">
        <label class="displayLabel">Glycol:</label>
        <input type="number" class="inputValue" [(ngModel)]="coilRequest.glycolPercentage" [disabled]="true"/>
        <label class="unitLabel">%</label>
      </div>
    }
    @if (coilRequest.isElectricHeat) {
      <div class="detailRow">
        <label class="displayLabel">E-Heat KW:</label>
        <label class="displayValue">{{ coilRequest.electricHeatKilowatts }}</label>
      </div>
    }
    @if (coilRequest.isElectricHeat) {
      <div class="detailRow">
        <label class="displayLabel">E-Heat Voltage:</label>
        <label class="displayValue">{{ coilRequest.electricHeatVoltage }}</label>
      </div>
    }
  </div>
</fieldset>
